"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Error = function Error(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#fff" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.375 9.688c0-1.72-.469-3.36-1.328-4.844a9.487 9.487 0 0 0-3.516-3.516C13.047.468 11.406 0 9.687 0 7.93 0 6.329.469 4.845 1.328c-1.485.86-2.696 2.031-3.555 3.516A9.569 9.569 0 0 0 0 9.687c0 1.758.43 3.36 1.29 4.844a9.695 9.695 0 0 0 3.554 3.555c1.484.86 3.086 1.289 4.843 1.289 1.72 0 3.36-.43 4.844-1.29 1.485-.858 2.656-2.07 3.516-3.554.86-1.484 1.328-3.086 1.328-4.844zm-8.505.062l2.518-2.521a.516.516 0 0 0 .104-.314.437.437 0 0 0-.125-.317l-.469-.47c-.157-.156-.412-.185-.654 0L9.746 8.627l-2.52-2.518c-.194-.145-.475-.136-.632.02l-.469.47A.437.437 0 0 0 6 6.915c0 .115.036.221.125.337L8.623 9.75l-2.519 2.52a.516.516 0 0 0-.104.315c0 .125.044.235.125.316l.47.47c.157.156.412.187.654 0l2.497-2.498 2.521 2.518a.516.516 0 0 0 .314.105.437.437 0 0 0 .317-.125l.469-.47a.437.437 0 0 0 .125-.316.528.528 0 0 0-.125-.338L10.87 9.75z",
    id: "error"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    xlinkHref: "#error",
    fillRule: "evenodd"
  }));
};

var _default = Error;
exports["default"] = _default;
module.exports = exports["default"];